import { images } from "../constants";

const testimonials = [  
    {
        id: 1,
        image: images.testimonial1,
        name: 'Michael Thompson',
        title: 'Local Resident',
        content: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Eum aspernatur quod quis aliquam sit excepturi totam amet minima dolore ut atque eligendi, ipsum iste earum at necessitatibus. Nihil, impedit at.'
    },
    {
        id: 2,
        image: images.testimonial2,
        name: 'Emily Roberts',
        title: 'Local Business Owner',
        content: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Eum aspernatur quod quis aliquam sit excepturi totam amet minima dolore ut atque eligendi, ipsum iste earum at necessitatibus. Nihil, impedit at.'
    },
    {
        id: 3,
        image: images.testimonial3,
        name: 'Natalie Scott',
        title: 'Community Leader',
        content: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Eum aspernatur quod quis aliquam sit excepturi totam amet minima dolore ut atque eligendi, ipsum iste earum at necessitatibus. Nihil, impedit at.'
    },
    {
        id: 4,
        image: images.testimonial4,
        name: 'Christopher Turner',
        title: 'Local Volunteer',
        content: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Eum aspernatur quod quis aliquam sit excepturi totam amet minima dolore ut atque eligendi, ipsum iste earum at necessitatibus. Nihil, impedit at.'
    },
];

export default testimonials;